var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.062 6.27h11.882M10.961 8.873h.006M8.003 8.873h.006M5.039 8.873h.006M10.961 11.464h.006M8.003 11.464h.006M5.039 11.464h.006M10.696 1.333v2.194M5.31 1.333v2.194",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.825 2.386H5.181C3.223 2.386 2 3.476 2 5.481v6.034c0 2.036 1.223 3.152 3.18 3.152h5.64c1.963 0 3.18-1.097 3.18-3.102V5.481c.006-2.004-1.21-3.095-3.175-3.095z",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgIconCalendarGray;